/**
 * Hook para Dispatch Inteligente
 * Aplica automaticamente o Global Request Manager em qualquer dispatch
 */

import { useDispatch } from "react-redux";
import { AppDispatch } from "@/store";
import { useGlobalRequestManager } from "@/utils/globalRequestManager";
import { useCallback } from "react";

export const useSmartDispatch = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { interceptDispatch } = useGlobalRequestManager();

  /**
   * Dispatch inteligente que previne requisições duplicadas automaticamente
   */
  const smartDispatch = useCallback(
    async (thunk: any, params?: any) => {
      return interceptDispatch(dispatch, thunk, params);
    },
    [dispatch, interceptDispatch],
  );

  return {
    dispatch, // dispatch original para casos especiais
    smartDispatch, // dispatch inteligente (usar por padrão)
  };
};

export default useSmartDispatch;
